import React from 'react';
import Button from 'olive-react-myoneui/lib/Button';
import { checkCircleFill, checkCircleComplete, clockIcon } from "../../../constants/icons";
import Accordion from 'olive-react-myoneui/lib/Accordion';
import { ProgressBar, ProgressValue, ProgressWrap } from 'olive-react-myoneui';

const CourseProgressAccordion = ({
  className,
  lectures,
  maxAttempts,
  enableSequentialProgress,
  onRetryClick,
  onStartClick,
  onContinueClick,
  onGenerateCertificateClick,
  hasCertificate,
  lectureCount,
  isCertificateGenerated
}) => {
  const updateLectureStatuses = (lectures) => {
    return lectures.map((lecture) => {
      if (lecture.subTopics?.length) {
        const allSubTopicsCompleted = lecture.subTopics.every(
          (subTopic) => subTopic.status === "completed"
        );
        lecture.status = allSubTopicsCompleted ? "completed" : lecture.status;
      }
      return lecture;
    });
  };

  const renderActionButton = (item, isDisabled, prevStatus) => {
    if (item.status === "completed") {
      return (
        <Button variant="secondary" className="btn-round btn-sm py-2 text-white" onClick={(e) => onRetryClick(item,e)}>
          View
        </Button>
      );
    }
    if (item.status === "notStarted") {
      return (
        <Button
          variant="primary"
          className="btn-round btn-sm py-2"
          disabled={isDisabled}
          onClick={(e) => onStartClick(item, prevStatus, e)}
        >
          Start
        </Button>
      );
    }
    return (
      <Button
        variant="primary"
        className="btn-round btn-sm py-2"
        disabled={isDisabled}
        onClick={(e) => onContinueClick(item, e)}
      >
        Continue
      </Button>
    );
  };

  const updatedLectures = updateLectureStatuses(lectures);
  const isCourseCompleted = updatedLectures.every(
    (lecture) => lecture.status === "completed"
  );
  return (
    <div className={`${className || ""} myk__stu-courses-progress-wrapper`}>
      <Accordion alwaysOpen>
        {updatedLectures.map((lecture, index) => {
          const isLectureDisabled =
            enableSequentialProgress &&
            (index > 0 && updatedLectures[index - 1].status !== "completed");

          return (
            <Accordion.Item
              key={index}
              eventKey={`lecture-${index}`}
              className={isLectureDisabled ? "disabled" : lecture.status}
            >
              <Accordion.Header as="div" className="flex-wrap">
                {lecture.status === "completed" ? checkCircleFill : checkCircleComplete}
                <h3>{index + 1}. {lecture.title}</h3>
                <ul className="m-0 p-0 d-flex align-items-center gap-4 list-style-none">
                  {parseInt(lecture.duration) > 0 && 
                  (<li>{clockIcon} <span>Duration: {lecture.duration} min</span></li>)
                  }
                </ul>
              </Accordion.Header>
              <Accordion.Body className="pt-1">
                {lecture.subTopics?.length > 0 ? (
                  <Accordion alwaysOpen className="myk__stu-lecture-subtopics">
                    {lecture.subTopics.map((subTopic, subIndex) => {
                      const isSubLectureDisabled = enableSequentialProgress && (subIndex > 0 && lecture.subTopics[subIndex - 1].status !== "completed");
                      const prevSubLectureStatus = (subIndex > 0 && lecture.subTopics[subIndex - 1].status === "completed") ? 1 : 0;
                      return (
                      <Accordion.Item
                        key={subIndex}
                        eventKey={`lecture-${index}-subTopic-${subIndex}`}
                        className={isSubLectureDisabled ? "disabled" : subTopic.status}
                      >
                        <Accordion.Header as="div" className="flex-wrap">
                          {subTopic.status === "completed" ? checkCircleFill : checkCircleComplete}
                          <h4>{subIndex + 1}. {subTopic.title}</h4>
                          {subTopic.showProgressBar === 'enable' && (
                          <div className="myk__stu-subject_progress  w-100">
                            <ProgressWrap>
                              <ProgressBar
                              variant={'success'}
                              now={Math.round(subTopic.progressPercentage)}
                              />
                              <ProgressValue ProgressPercentage={`${Math.round(subTopic.progressPercentage)}%`} />
                            </ProgressWrap>
                          </div>
                          )}
                          <ul className="m-0 p-0 d-flex align-items-center gap-4 list-style-none">
                            {/* {subTopic.showAttempts === 'enable' && 
                            (<li>Attempts: <span><strong>{subTopic.attempts}</strong></span></li>)
                            } */}
                            {subTopic.showDuration === 'enable' && (
                            <li>{clockIcon} <span>Duration: {subTopic.duration} min</span></li>
                            )}
                          </ul>
                        </Accordion.Header>
                        <Accordion.Body className="pt-1">
                          {renderActionButton(subTopic, isSubLectureDisabled, prevSubLectureStatus)}
                        </Accordion.Body>
                      </Accordion.Item>
                      );
                    }
                    )}
                  </Accordion>
                ) : (
                  <div className="d-flex align-items-center gap-3">
                    {renderActionButton(lecture, isLectureDisabled)}
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
        {lectureCount === '0' && (
          <Accordion.Item>
            <Accordion.Header as="div" className="flex-wrap">
              <h3>No Lectures Available</h3>
            </Accordion.Header>
          </Accordion.Item>
        )}
        {hasCertificate == '1' ? (
        <Accordion.Item
          eventKey="certificate"
          className={isCourseCompleted ? "completed accordion-item-certificate" : "in-progress accordion-item-certificate"}
        >
          <Accordion.Header as="div" className="flex-wrap">
            {isCourseCompleted ? checkCircleFill : checkCircleComplete}
            <h3>
              {updatedLectures.length + 1}. Certificate{" "}
            </h3>
          </Accordion.Header>
          <Accordion.Body className="pt-0">
            <>
              <p>Click on the "Generate Certificate" button to download your certificate.</p>
              <Button variant="primary" className="btn-round btn-sm py-2" onClick={onGenerateCertificateClick}>
                {isCertificateGenerated ? 'View Certificate' : 'Generate Certificate Link'} 
              </Button>
            </>
          </Accordion.Body>
        </Accordion.Item>
        ) : ('')}
      </Accordion>
    </div>
  );
};

export default CourseProgressAccordion;
